export default function AccessSection() {
  return (
    <section className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            アクセス
          </h2>
          <p className="text-gray-600 text-lg">
            廿日市市大野の学習塾NICK
          </p>
        </div>

        <div className="bg-white rounded-3xl overflow-hidden shadow-xl">
          <div className="h-[450px]">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=34.2918,132.2724&zoom=17"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="学習塾NICK 地図"
            ></iframe>
          </div>

          <div className="p-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <h3 className="text-2xl font-bold text-[#1a2332] mb-6">
                  教室情報
                </h3>

                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">住所</p>
                      <p className="text-gray-600">
                        〒739-0400<br />
                        広島県廿日市市大野中央四丁目４－１６
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">電話番号</p>
                      <p className="text-gray-600">0829-78-1638</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">開校時間</p>
                      <p className="text-gray-600">
                        平日：16:00〜21:00<br />
                        土日：14:00〜21:00<br />
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-parking-box-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">駐車場</p>
                      <p className="text-gray-600">専用駐車場完備（5台）</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-[#1a2332] mb-6">
                  アクセス方法
                </h3>

                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-train-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">電車でお越しの方</p>
                      <p className="text-gray-600">
                        JR山陽本線「大野浦駅」より徒歩12分
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-bus-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">バスでお越しの方</p>
                      <p className="text-gray-600">
                        「大野中央」バス停より徒歩3分
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#4a90e2]/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-car-line text-xl text-[#4a90e2]"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] mb-1">お車でお越しの方</p>
                      <p className="text-gray-600">
                        国道2号線「大野中央」交差点より車で2分<br />
                        専用駐車場完備で送迎も安心
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 bg-[#faf8f5] rounded-2xl p-6">
                  <h4 className="font-bold text-[#1a2332] mb-3">通塾エリア</h4>
                  <p className="text-gray-600 leading-relaxed">
                    <strong>廿日市市大野</strong>を中心に、<strong>廿日市市</strong>全域、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からも多くの学生が通塾しています。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto leading-relaxed">
            <strong>廿日市市大野エリア</strong>で<strong>学習塾</strong>をお探しの方へ。学習塾NICKは、地域密着型の<strong>中学生向け学習塾</strong>として、<strong>定期テスト対策</strong>と<strong>高校受験対策</strong>に特化した指導を行っています。まずは<strong>無料体験</strong>からお気軽にお越しください。
          </p>
        </div>
      </div>
    </section>
  );
}
